var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfobutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2013"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 16",
    cx: 9.26197,
    cy: 9.26154,
    rx: 9.26197,
    ry: 9.26154,
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    x: 7.71826,
    y: 7.20337,
    width: 3.08731,
    height: 8.23246,
    rx: 1.54366,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 7.71826,
    y: 3.08716,
    width: 3.08731,
    height: 3.08718,
    rx: 1.54359,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfobutton);
export default __webpack_public_path__ + "static/media/infobutton.173a6c33a2d65ff2da6bace0e6372b18.svg";
export { ForwardRef as ReactComponent };